import { Dropdown, DropdownOption } from '@mayoral/ui';
import { SelectChangeEvent, styled } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { FC } from 'react';

const LangDropdown = styled(Dropdown, {
  name: 'LoginLangDropdown',
  slot: 'Root',
})({
  fontSize: 14,
  height: 37,
  top: '3px',
});

type LoginLangDropdownProps = {
  manager?: boolean;
};

const LoginLangDropdown: FC<LoginLangDropdownProps> = ({ manager = false }) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { locale, locales } = router;

  const options: DropdownOption[] = locales.map((value) => ({
    label: t(value.toUpperCase()),
    value,
  }));

  const handleChange = (e: SelectChangeEvent) => {
    const { value } = e.target;
    const path = manager ? '/login/manager' : '/login';
    router.push(path, path, { locale: value });
  };

  return (
    <LangDropdown
      value={locale}
      options={options}
      onChange={handleChange}
      MenuProps={{ PaperProps: { style: { maxHeight: 260 } } }}
    />
  );
};

export default LoginLangDropdown;
